import EventLoggerProvider from 'EventLogger/EventLoggerProvider';

export function useEventLogger() {
    return EventLoggerProvider.get()!;
}
